<template>
  <div class="ml-5 mr-5">

    <v-dialog v-model="displayKeywordOverlay" persistent max-width="600px">
    <v-card style="padding:20px">
      
      <v-card-title>
        <span 
          :class="this.window.width > 500 ? 'text-h4 no-highlight-text' : 'text-h6 no-highlight-text'"
           style="text-align:center; width:100%; word-break: normal;">{{this.$t("filter_by_keywords_heading")}}</span>
        <v-icon v-on:click="applyKeywords()" class="position-top-right image-scale-2 mt-1 mr-2" style="font-size: 30px;" x-large>fas fa-times</v-icon>
      </v-card-title>
        
      <v-card-text style="padding: 3px">
        <v-autocomplete multiple v-model="keywordEntry.keywordsToApply"  append-outer-icon="fas fa-filter .no-highlight-text" :items="keywordEntry.possibleKeywords" :error="autocompleteHasError"></v-autocomplete>
      </v-card-text>

      <v-card-actions style="padding: 0px 16px;">
        <div class="row justify-content-between" >
          <v-btn class="primary col-xs-3 const-m-width" @click="keywordEntry.keywordsToApply = [];">
            {{this.$t("clear_all")}}
          </v-btn>
          <v-btn class="primary col-xs-3 const-m-width" @click="applyKeywords()">
            {{this.$t("apply")}}
          </v-btn>
        </div>
      </v-card-actions>

    </v-card>
  </v-dialog>

  <!-- Courses Dialog -->
  <v-dialog v-model="displayCoursesOverlay" persistent max-width="600px">
    <v-card style="padding:20px">
      
      <v-card-title>
        <span 
          :class="this.window.width > 500 ? 'text-h4 no-highlight-text' : 'text-h6 no-highlight-text'"
           style="text-align:center; width:100%; word-break: normal;">{{this.$t("filter_by_courses_heading")}}</span>
        <v-icon v-on:click="applyCourses()" class="position-top-right image-scale-2 mt-1 mr-2" style="font-size: 30px;" x-large>fas fa-times</v-icon>
      </v-card-title>
        
      <v-card-text style="padding: 3px">
        <v-autocomplete multiple v-model="courseEntry.coursesToApply"  append-outer-icon="fas fa-filter .no-highlight-text" :items="courseEntry.possibleCourses" :error="autocompleteHasError"></v-autocomplete>
      </v-card-text>

      <v-card-actions style="padding: 0px 16px;">
        <div class="row justify-content-between" >
          <v-btn class="primary col-xs-3 const-m-width" @click="courseEntry.coursesToApply = [];">
            {{this.$t("clear_all")}}
          </v-btn>
          <v-btn class="primary col-xs-3 const-m-width" @click="courseEntry.coursesToApply = courseEntry.possibleCourses">
            {{this.$t("add_all")}}
          </v-btn>
          <v-btn class="primary col-xs-3 const-m-width" @click="applyCourses()">
            {{this.$t("apply")}}
          </v-btn>
        </div>
      </v-card-actions>

    </v-card>
  </v-dialog>

  <div v-bind:class="{'blur': displayKeywordOverlay || displayCoursesOverlay}">
    <div class="row justify-content-between" >
      <div :class="this.window.width < 1600 ? 'col-sm-4' : 'col-sm-3'">
        <v-card class="pa-2" elevation="1" v-on:click="toggleKeywordOverlay()">
          <span class="text-responsive"> {{filterKeywordsText}} <v-icon >fas fa-filter</v-icon> </span>
        </v-card>
      </div>

      <div :class="this.window.width < 1600 ? 'col-sm-4' : 'col-sm-3'">
          <v-card class="pa-2" elevation="1">
            <span class="row justify-content-around">
              

              <b-form-select class="period-filter-dropdown" v-model="periodForFilter.inputValueBegin" :options="periodForFilter.allYears" v-on:change="applyTimePeriodFilter(periodForFilter.inputValueBegin, true)"></b-form-select>
              <span class="text-center">{{this.$t("until")}}</span>
              <b-form-select class="period-filter-dropdown" v-model="periodForFilter.inputValueEnd" :options="periodForFilter.allYears" v-on:change="applyTimePeriodFilter(periodForFilter.inputValueEnd, false)"></b-form-select>

              <!-- <b-dropdown :text="[[filter.yearFrom]]" size="sm" class="period-filter">
                <b-dropdown-item v-for="year in periodForFilter.allYears" :key="year" @click="filter.yearFrom = year; checkPeriod();applyfilter() ">
                  {{year}}
                </b-dropdown-item>  
              </b-dropdown>

              <span class="text-center">{{this.$t("until")}}</span>

              <b-dropdown :text="[[filter.yearTo]]" size="sm" class="period-filter">
                <b-dropdown-item v-for="year in periodForFilter.allYears" :key="year" @click="filter.yearTo = year; checkPeriod();applyfilter()">
                  {{year}}
                </b-dropdown-item>  
              </b-dropdown> -->

              <v-icon v-if="periodForFilter.error" style="padding-right:20px">
                fas fa-exclamation-triangle
              </v-icon>


  

              <!-- <span class="text-left"> {{filter.yearFrom}}</span>
              <span class="text-center">{{this.$t("until")}}</span>
              <span class="text-right">{{filter.yearTo}}</span> -->
              

              <!--
              <date-picker v-model="filter.yearFrom" :config="options" id="exam_end" class="text-left"></date-picker>
              <span class="text-center">{{this.$t("until")}}</span>
              <date-picker v-model="filter.yearTo" :config="options" id="exam_end" class="text-right"></date-picker>
              -->
            </span>
          </v-card>
      </div> 
      <div :class="this.window.width < 1600 ? 'col-sm-4' : 'col-sm-3'">
        <v-card class="pa-2" elevation="1" v-on:click="toggleCourseOverlay()">
          <span class="text-responsive"> {{filterCoursesText}} <v-icon >fas fa-filter</v-icon> </span>
        </v-card>
      </div>
    </div>


    <!-- KPI's -->

    <div class="row justify-content-between mt-5">
      <key-card v-for="(chart, i) in charts" v-show="chart.chartType == 'KPI'" :key="i" :description="chart.description" v-on:fetchTheses="fetchTheses" :externalLink="chart.externalLink" :value="chart.data" :headerIcon="chart.icon" :color="chart.color" class="col-sm-4"></key-card>
    </div>

    <!-- Charts  -->

    <div class="row justify-content-between" style="margin-top:45px !important">
      <chart-card ref="update" v-for="(chart, i) in charts" :key="i" style="margin-top:45px !important" v-show="chart.chartType != 'KPI'" :chart="chart" v-on:fetchTheses="fetchTheses" :color="chart.color" :headline="chart.title" :description="chart.description" v-bind:class="{'col-md-4': chart.size == 'SMALL', 'col-md-8': chart.size == 'MEDIUM', 'col-md-12': chart.size == 'LARGE'}"></chart-card>
    </div>

    <div class="row justify-content-between wordcloud-loader" style="margin-top: 45px !important" v-show="showLoadingWordCloud">
      <span class="wordcloud-loader-text">Wortwolke wird geladen...</span>
      <div class=loadingCircle>
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
      </div>
    </div>

    <div class="row justify-content-between" style="margin-top: 45px !important; padding: 15px;">
      <vue-word-cloud 
        :words="wordcloud.words" 
        :color="([, weight]) => weight > 150 ? '#ED7925' : weight > 75 ? '#0069B4' : '#3b94d4'" 
        :spacing="wordcloud.spacing"
        font-family="Roboto"
        class="word-cloud"
        @update:progress="wordcloudProgressHandler"
        >
        <template slot-scope="{text, weight, word}">
          <div :title="weight" style="cursor: pointer;" @click="addKeyword(word)">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ text }}
                </span>
              </template>
              <span>{{ text }} ({{ weight }})</span>
            </v-tooltip>
          </div>
        </template>
      </vue-word-cloud>
    </div>

  <!-- 
  <v-dialog v-model="displayKeywordOverlay" persistent max-width="600px">
    <v-card>
      
      <v-card-title>
        <span class="text-h4" style="text-align:center; width:100%; word-wrap:break-word;">{{this.$t("filter_by_keywords_heading")}}</span>
        <v-icon v-on:click="toggleKeywordOverlay()" class="position-top-right image-scale-2 mt-1 mr-2" x-large>fas fa-times</v-icon>
      </v-card-title>
      
      <v-card-text>
        
          <v-text-field hide-details="auto" dense v-model="keywordToAdd" :placeholder="[[ evaluaionHint ]]" append-outer-icon="fas fa-filter"/>
        
        <v-autocomplete v-model="keywordToAdd" append-outer-icon="fas fa-filter" :items="possibleKeywords" :error="autocompleteHasError"></v-autocomplete>
        
        
        <v-chip-group column>
          <v-chip
            v-for="(keyword, index) in filter.keywords"
            :key="keyword"
            label
            close
            @click:close="deleteKeyword(index);">
            
            {{keyword}}

          </v-chip>
        </v-chip-group>

      </v-card-text>

      <v-card-actions>
        <div class="row justify-content-around">
          <v-btn class="primary col-sm-5" @click="filter.keywords = [];">
            {{this.$t("clear_all")}}
          </v-btn>
          <v-btn class="primary col-sm-5" @click="addKeyword(keywordToAdd)">
            {{this.$t("save")}}
          </v-btn>
    
    <div id="content" v-bind:class="{'blur':displayKeywordOverlay}">
      <div id="filter-section"> 
        <div class="filter-box">
          <div v-on:click="toggleKeywordOverlay()" class="filter-container left white-container pointer">
            <p>{{filterKeywordsText}}</p>
            <v-icon class="space-to-left">fas fa-filter</v-icon>
          </div>
        </div>
      </v-card-actions>
      <div class="filter-box ">
        <div class="filter-container center white-container">
          <p>{{filter.yearFrom}}</p>
          <p class="space-to-left">{{this.$t("until")}}</p>
          <p class="space-to-left">{{filter.yearTo}}</p>
        </div> 
      </div>
      <div class="filter-box"> 
        <div class="filter-container right">
          <input v-model="filter.evaluationText" :placeholder="[[ evaluaionHint ]]">
          <v-icon>fas fa-search</v-icon>
        </div>
      </div>
    </div>
  </div>
  -->

  

  </div>
</template>

<script>
import LineChart from './charts/Line'
import BarChart from './charts/Bar'
import RadarChart from './charts/Radar'
import BubbleChart from './charts/Bubble'
import PieChart from './charts/Pie'
import KeyCard from './custom/KeyCard.vue'
import ChartCard from './custom/ChartCard.vue'

import VueWordCloud from 'vuewordcloud';


export default {
  components: {
    LineChart,
    BarChart,
    RadarChart,
    BubbleChart,
    PieChart,
    KeyCard,
    ChartCard,
    VueWordCloud
  },

  data() {
    return {

      // chartType:"BUBBLE"
      window: {
        width: 0,
        height: 0
      },
      charts: [],
      data: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },

      wordcloud: {
        words: [],
        spacing: 0.37,
        selectedWord: null,
      },

      showLoadingWordCloud: true,
      progressWasNotNull: false,

      filter: {
        keywords: [],
        courses: [],
        evaluationText: "",
        yearFrom: 0,
        yearTo: 0,
        // period: {
        //   begin: 0,
        //   end: 0,
        // },
      },
      keywordEntry: {
        possibleKeywords: [],
        keywordToAdd: "",
        keywordsToApply: [],

        autocompleteHasError: false,
      },
      courseEntry: {
        possibleCourses: [],
        courseToAdd: "",
        coursesToApply: [],

        autocompleteHasError: false,
      },
      
      periodForFilter: {
        begin: 1991,
        end: 2100,

        inputValueBegin: 0,
        inputValueEnd: 0,

        allYears: [],
        error: false
      },

      displayKeywordOverlay: false,
      displayCoursesOverlay: false,

      // Placeholder Data
      keycard:{
          color: "green",
          headerIcon: "fas fa-home",
          description:"Das ist die erste Zahl",
          value: 12978
        },
      chartcard:{
          color: "red",
          headline: "Das ist die erste Kachel",
          description:"Hier stehen weitere Informationen",
      },

      options:{
        format: 'DD.MM.YYYY HH:mm',
        useCurrent: false,
        icons:{
          time: 'far fa-clock',
          date: 'far fa-calendar',
          up: 'fas fa-arrow-up',
          down: 'fas fa-arrow-down',
          previous: 'fas fa-chevron-left',
          next: 'fas fa-chevron-right',
          today: 'fas fa-calendar-check',
          clear: 'far fa-trash-alt',
          close: 'far fa-times-circle',
        },
      },
    };
  },
  computed: {
    filterKeywordsText() {
      if(this.window.width < 1070 && this.window.width > 574) {
        return this.$t("keyword_filter_short") + this.filter.keywords.length;
      } else {
        var keywordSize = this.filter.keywords.length;
        if(keywordSize == 1) {
          return this.$t("keyword_filter_first_part") + " " + keywordSize + " " + this.$t("keyword_filter_second_part_singular");
        } else { 
          return this.$t("keyword_filter_first_part") + " " + keywordSize + " " + this.$t("keyword_filter_second_part_plural");
        }
      }
    },
    filterCoursesText() {
      if(this.window.width < 1070 && this.window.width > 574) {
        return this.$t("course_filter_short") + this.filter.courses.length;
      } else {
        var courseSize = this.filter.courses.length;
        if(courseSize == 1) {
          return this.$t("course_filter_first_part") + " " + courseSize + " " + this.$t("course_filter_second_part_singular");
        } else { 
          return this.$t("course_filter_first_part") + " " + courseSize + " " + this.$t("course_filter_second_part_plural");
        }
      }
    },
    evaluaionHint() {
      if(this.window.width < 800 && this.window.width > 574) {
        return this.$t("search_for_evaluation_short");
      } else {
        return this.$t("search_for_evaluation");
      }
    },
    navHasCollapsed() {
      return this.window.width > 1263;
    }
  },
  mounted() {
    // this.data = {
    //   labels: ["Januar", "Februar"],
    //   datasets: [
    //     {
    //       label: "Data 1",
    //       backgroundColor: "#005070",
    //       data: [40, 20]
    //     }
    //   ]
    // }
    this.setupVariables();
    this.fetchFilter();
    this.fetchCharts();
    this.fetchKeywords();
    this.fetchCourses();
    this.fetchKeywordsWeighted();
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.filter.yearFrom = this.periodForFilter.begin;

  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    toggleKeywordOverlay() {
      this.displayKeywordOverlay = !this.displayKeywordOverlay;
      if(this.displayKeywordOverlay) {
        this.keywordEntry.keywordsToApply = this.filter.keywords;
      }
    },
    toggleCourseOverlay() {
      this.displayCoursesOverlay = !this.displayCoursesOverlay;
      if(this.displayCoursesOverlay) {
        this.courseEntry.coursesToApply = this.filter.courses;
      }
    },
    setupVariables() {
      this.periodForFilter.end = new Date().getFullYear();

      this.periodForFilter.inputValueBegin = this.periodForFilter.begin;
      this.periodForFilter.inputValueEnd = this.periodForFilter.end;
      this.filter.yearFrom = this.periodForFilter.begin;
      this.filter.yearTo = this.periodForFilter.end;

      for(var i=this.periodForFilter.begin; i <= this.periodForFilter.end; i++) {
        this.periodForFilter.allYears.push(i);
      }
    },
    checkPeriod() {
      if(this.filter.yearFrom <= this.filter.yearTo) {
        this.periodForFilter.error = false;
      } else {
        this.periodForFilter.error = true;
      }

      console.log("error:" + this.periodForFilter.error);
    },
    deleteKeyword(index) {
      this.keywordEntry.keywordsToApply.splice(index, 1);
    },
    addKeyword(keyword) {
      this.filter.keywords = [];
      this.filter.keywords.push(keyword[0]);
      this.wordcloud.selectedWord = keyword[0];
      this.applyfilter();
    },
    applyKeywords() {
      this.toggleKeywordOverlay();
      this.filter.keywords = [];
      for(var i=0;i<this.keywordEntry.keywordsToApply.length; i++) {
        this.filter.keywords.push(this.keywordEntry.keywordsToApply[i]);
      }
      this.applyfilter();
    },
    applyCourses() {
      this.toggleCourseOverlay();
      this.filter.courses = [];
      for(var i=0;i<this.courseEntry.coursesToApply.length; i++) {
        this.filter.courses.push(this.courseEntry.coursesToApply[i]);
      }
      this.applyfilter();
    },
    editedPeriod() {
      if(filter.yearFromn > filter.yearTo) {

      }
    },

    fetchCharts() {
      var _this = this;
      this.$axios
        .get("/api/charts/home")
        .then(function (response) {
          _this.charts = response.data;
          for (let i = 0; i < _this.charts.length; i++) {
            const chart = _this.charts[i];
            _this.fetchDataForChart(chart, i);
          }
          // console.log(this.charts);
        })
        .catch(this.onError);
    },

    fetchDataForChart(chart, index){
      if(chart.dataPath == null){
        console.error("Ein Programmfehler liegt vor. Das Attribut für den API-Pfad konnte nicht für die Grafik bestimmt werden.");
        return;
      }
      var _this = this;
      this.$axios
        .get(chart.dataPath)
        .then(function (response) {
          _this.charts[index].data = {
            labels: [],
            datasets: [],
          };
          _this.charts[index].data = response.data;
          Vue.set(_this.charts[index], 'data', response.data);
          _this.$forceUpdate();
          _this.$refs.update[index].update();
        })
        .catch(this.onError);
    },
    fetchKeywordsWeighted() {
      // Show Loading Circle for Tag Cloud
      // showLoadingCircle(true);

      var _this = this;
      this.$axios
        .get("/api/data/keywords/weighted")
        .then(function (response) {
          _this.wordcloud.words = response.data;
        })
        .catch(this.onError);
    },
    fetchKeywords() {
      var _this = this;
      this.$axios
        .get("/api/data/keywords")
        .then(function (response) {
          _this.keywordEntry.possibleKeywords = response.data;
        })
        .catch(this.onError);
    },
    fetchCourses() {
      var _this = this;
      this.$axios
        .get("/api/data/courses")
        .then(function (response) {
          _this.courseEntry.possibleCourses = response.data;
        })
        .catch(this.onError);
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    applyTimePeriodFilter: function(newVal, isBeginning) {
      if(newVal) {
        if(isBeginning) {
          this.filter.yearFrom = newVal;
        } else {
          this.filter.yearTo = newVal;
        }
      }
        this.checkPeriod();
        this.applyfilter();
    },
    applyfilter(){
      var _this = this;
      this.$axios
        .post('/api/data/filter',this.filter)
        .then( function (response){
          for (let i = 0; i < _this.charts.length; i++) {
            const chart = _this.charts[i];
            _this.fetchDataForChart(chart, i);
            _this.$refs.update[i].update();
          }
          _this.fetchKeywordsWeighted();
          if(_this.wordcloud.selectedWord != null){
            _this.$router.push("dashboard");
          }
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },
    fetchFilter(){
      var _this = this;
      this.$axios
        .get("/api/data/filter")
        .then(function (response) {
          _this.filter = response.data;
          _this.periodForFilter.inputValueBegin = _this.filter.yearFrom;
          _this.periodForFilter.inputValueEnd = _this.filter.yearTo;
          _this.checkPeriod();
        })
        .catch(this.onError);
    },

    fetchTheses(path){
      var _this = this;

      this.$axios
        .get(path + "/wilbert")
        .then(function (response) {
          window.open(response.data, '_blank').focus();
        })
        .catch(function(err){
          console.error(err);
        }).finally(() => {
          showLoadingCircle(false);
        });
    },

    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      //this.filterKeywordsText();
      //this.evaluaionHint();
    },


    wordcloudProgressHandler(progress){
      if(progress && this.showLoadingWordCloud){
        this.progressWasNotNull = true;
        this.showLoadingWordCloud = true;
      }else if(this.progressWasNotNull){
        this.showLoadingWordCloud = false;
      }
    }
  },
  
};
</script>

<style>
</style>
